import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import type { GenerateGeneralPDFResponseDTO } from '@/core/dto/resolution-886-report/generate-general-pdf';

interface DownloadGeneralPDFParams {
	organization_id: string;
	company_id: string;
	locale: string;
	report_id: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886ReportDownload = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: DownloadGeneralPDFParams) => Service.downloadGeneralPDF(params),
		onSuccess: (data: GenerateGeneralPDFResponseDTO) => {
			let archive = document.createElement('a');
			archive.target = '_blank';
			archive.href = data.url;
			archive.click();
			archive.remove();
			queryClient.invalidateQueries([QUERY_KEYS.GENERATE_RESOLUTION_886_GENERAL_PDF]);
		},
		onError: () => {
			message.error(I18n.get('Error generating PDF'));
		}
	});
};
